import { Button, ButtonMore, Flex, FlexItem } from 'mailup-web-components'
import { saveCampaignCallback } from 'Pages/Campaign/recoil/callbacks/callbacks'
import { pageState } from 'Pages/Campaign/recoil/state/page'
import { useIntl } from 'react-intl'
import { useParams } from 'react-router-dom'
import { useRecoilCallback, useRecoilValue, useSetRecoilState } from 'recoil'
import { modalConfirmIgnoreChangesState } from '../../../recoil/state/modals'

export const SelectTemplateButtons = () => {
  const intl = useIntl()
  const { idCampaign } = useParams()

  const { displayCarousel } = useRecoilValue(pageState)
  const setPageState = useSetRecoilState(pageState)

  const saveCampaign = useRecoilCallback(saveCampaignCallback, [])
  const setModalIgnoreSaves = useSetRecoilState(modalConfirmIgnoreChangesState)

  const handleClickBtn = (value) => {
    switch (value) {
      case 'EDIT': {
        saveCampaign('EDIT')
        break
      }
      case 'EXIT': {
        setModalIgnoreSaves((prev) => ({
          ...prev,
          show: true,
          redirectRoute: `/automation/contentsCampaign/list`
        }))
        break
      }
      case 'BACK': {
        setModalIgnoreSaves((prev) => ({
          ...prev,
          show: true,
          redirectRoute: `/automation/contentsCampaign/${idCampaign}`
        }))
        break
      }
    }
  }

  const onClickBtnMore = () => {
    setPageState((prev) => ({
      ...prev,
      displayCarousel: !prev.displayCarousel
    }))
  }

  return (
    <Flex>
      <FlexItem margin='0 8px 0 0'>
        <ButtonMore
          callback={onClickBtnMore}
          text={intl.formatMessage({
            id: 'Load.ContentsCampaignWizard.TemplateSelect'
          })}
          opened={displayCarousel}
        />
      </FlexItem>

      <FlexItem margin='0 8px 0 0'>
        <Button kind='secondary' onClick={() => handleClickBtn('BACK')}>
          {intl.formatMessage({ id: 'Load.Common.BtnBack' })}
        </Button>
      </FlexItem>
      <FlexItem margin='0 8px 0 0'>
        <Button
          kind='secondary'
          onClick={() => handleClickBtn('EXIT')}
          data-mu-test='save-exit'
        >
          {intl.formatMessage({ id: 'Load.Common.Exit' })}
        </Button>
      </FlexItem>
      <FlexItem>
        <Button
          kind='primary'
          data-mu-test='save-save'
          onClick={() => handleClickBtn('EDIT')}
        >
          {intl.formatMessage({
            id: 'Load.ContentsCampaignWizard.TemplateTitle'
          })}
        </Button>
      </FlexItem>
    </Flex>
  )
}
